import { FaWhatsapp, FaTelegram, FaFacebook, FaInstagram, FaTiktok } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { Link2, Check } from "lucide-react";
import { motion } from "framer-motion";
import { useState } from "react";

const SHARE_TEXT = "27 Brutal Truths About Why You're Still Losing in Trading - Check this out!";

const platforms = [
  {
    name: "WhatsApp",
    icon: FaWhatsapp,
    color: "#25D366",
    getUrl: () => `https://wa.me/?text=${encodeURIComponent(SHARE_TEXT + " " + window.location.href)}`,
  },
  {
    name: "Telegram",
    icon: FaTelegram,
    color: "#0088CC",
    getUrl: () => `https://t.me/share/url?url=${encodeURIComponent(window.location.href)}&text=${encodeURIComponent(SHARE_TEXT)}`,
  },
  {
    name: "Facebook",
    icon: FaFacebook,
    color: "#1877F2",
    getUrl: () => `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`,
  },
  {
    name: "X",
    icon: FaXTwitter,
    color: "#FFFFFF",
    getUrl: () => `https://twitter.com/intent/tweet?text=${encodeURIComponent(SHARE_TEXT)}&url=${encodeURIComponent(window.location.href)}`,
  },
  {
    name: "Instagram",
    icon: FaInstagram,
    color: "#E4405F",
    getUrl: () => `https://www.instagram.com/`,
  },
  {
    name: "TikTok",
    icon: FaTiktok,
    color: "#FFFFFF",
    getUrl: () => `https://www.tiktok.com/`,
  },
];

export default function SocialShare() {
  const [copied, setCopied] = useState(false);

  const copyLink = () => {
    navigator.clipboard.writeText(window.location.href).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div data-testid="social-share" className="flex flex-col items-center gap-5">
      <p className="text-[#A1A1AA] text-sm tracking-wide uppercase">Share this with a trader who needs it</p>
      <div className="flex gap-4 flex-wrap justify-center">
        {platforms.map((p, i) => (
          <motion.a
            key={p.name}
            href={p.getUrl()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`share-${p.name.toLowerCase()}`}
            className="w-12 h-12 rounded-full flex items-center justify-center border border-[#27272A] bg-[#121212] hover:border-[#FF007F] transition-all duration-300 hover:scale-110"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.08 }}
            title={`Share on ${p.name}`}
          >
            <p.icon size={20} color={p.color} />
          </motion.a>
        ))}
        {/* Copy link button */}
        <motion.button
          onClick={copyLink}
          data-testid="copy-link-btn"
          className="w-12 h-12 rounded-full flex items-center justify-center border border-[#27272A] bg-[#121212] hover:border-[#FF007F] transition-all duration-300 hover:scale-110"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.5 }}
          title="Copy link"
        >
          {copied ? <Check size={20} className="text-emerald-400" /> : <Link2 size={20} className="text-[#A1A1AA]" />}
        </motion.button>
      </div>
      {copied && (
        <span className="text-emerald-400 text-sm font-mono">Link copied to clipboard!</span>
      )}
    </div>
  );
}
